export enum SETTINGS_DETAIL_TABS {
  GENERAL = 'General',
  PRIVACY = 'Privacy',
  THEME = 'Theme',
  ADVANCED = 'Advanced',
}
